import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

const hideInitialPreloader = () => {
  const preloader = document.getElementById('preloader-active');
  if (!preloader) {
    return;
  }
  preloader.style.opacity = '0';
  preloader.style.transition = 'opacity 0.25s ease';
  window.setTimeout(() => {
    preloader.remove();
  }, 260);
};

if (document.readyState === 'complete') {
  window.requestAnimationFrame(hideInitialPreloader);
} else {
  window.addEventListener('load', hideInitialPreloader, { once: true });
}
